<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'

defineProps<{
  errors: string[]
}>()
</script>

<template>
  <div
    class="mt-2 font-sans bg-red-500/25 text-red-500 border border-red-500 border-dashed px-4 py-2 rounded-xl"
  >
    <label-base v-if="errors.length === 1" color="red">{{ errors[0] }}</label-base>
    <ul v-else class="list-inside list-disc">
      <li v-for="(val, i) in errors" :key="i">{{ val }}</li>
    </ul>
  </div>
</template>

<style scoped></style>
